<template>
    <div class="choice-input">
        <button
            v-for="item in props.items"
            :key="item.value"
            type="button"
            :class="classesForItem(item)"
            @click="emit('update:modelValue', item)"
            @keydown.enter="emit('update:modelValue', item)"
        >
            {{ item.label }}
        </button>
    </div>
</template>

<script setup lang="ts">
    interface Item {
        label: string;
        value: string;
    }

    interface Props {
        modelValue: Item;
        items: Item[];
    }

    const props = defineProps<Props>();
    const emit = defineEmits<{
        (e: 'update:modelValue', value: Item): void;
    }>();

    function classesForItem(item: Item) {
        return {
            'choice-input__item': true,
            'choice-input__item--active': item.value === props.modelValue.value,
        };
    }
</script>

<style scoped lang="scss">
    .choice-input {
        display: flex;
        flex-wrap: nowrap;
        background-color: var(--theme-colors-default--raspberry-pink-500);
        border-radius: size(md);
        padding: size(xs);
        gap: size(xs);
        user-select: none;

        &__item {
            background-color: transparent;
            border: none;
            font-size: size(sm);
            padding: size(sm);
            border-radius: size(md);
            color: var(--theme-colors-default--white);
            cursor: pointer;

            &--active {
                background-color: var(--theme-colors-default--white);
                color: var(--theme-colors-active--raspberry-pink-500);
            }
        }
    }
</style>
